import styled from 'styled-components';

import { Breakpoint, Color, FontWeight, Grid, ZIndex } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { InputValueBoxBaseStyle } from '../../theme';
import { Icon } from '../icon/icon.component';

import {
  OptionButtonProps,
  OptionButtonInnerProps,
  OptionsPopupProps,
} from './fullscreenDropdown.types';

export const Container: StyledComponent<'div'> = styled.div``;

export const InputContainer: StyledComponent<'button'> = styled.button.attrs({ type: 'button' })`
  ${InputValueBoxBaseStyle}
  position: relative;
`;

export const Value: StyledComponent<'span'> = styled.span`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: calc(100% - 60px);
  text-align: left;
  color: ${Color.Black};
`;

export const StyledIcon: StyledComponent<typeof Icon> = styled(Icon)`
  position: absolute;
  right: 19px;
  top: 50%;
  transform: translateY(-50%);
`;

export const OptionsPopup: StyledComponent<'div', OptionsPopupProps> = styled.div<OptionsPopupProps>`
  position: fixed;
  z-index: ${ZIndex.FullscreenDropdown};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${Color.Gray200};
  transition: 0.3s;
  overflow-y: auto;
  padding: 24px 40px 80px;
  ${({ $visible }: OptionsPopupProps): string => $visible ? `
    pointer-events: initial;
    opacity: 1;
  ` : `
    pointer-events: none;
    opacity: 0;
  `}

  @media ${Breakpoint.Desktop} {
    padding: 24px 32px 80px;
  }

  @media ${Breakpoint.SmallMobile} {
    padding: 24px 20px 80px;
  }
`;

export const TopSection: StyledComponent<'div'> = styled.div`
  padding-bottom: 25px;
  margin-bottom: 48px;
  border-bottom: 1px solid ${Color.Gray300};
  margin-top: 24px;
  max-width: ${Grid.Desktop};
`;

export const TopSectionInner: StyledComponent<'div'> = styled.div`
  max-width: ${Grid.DesktopHalf};
  margin: 0 auto;
`;

export const CloseButton: StyledComponent<'button'> = styled.button.attrs({ type: 'button' })`
  margin-bottom: 80px;
`;

export const OptionsPopupTitle: StyledComponent<'div'> = styled.div`
  font-weight: ${FontWeight.Medium};
  font-size: 30px;
  line-height: 38px;
  letter-spacing: -0.01em;
  color: ${Color.Black};
`;

export const BottomSection: StyledComponent<'div'> = styled.div`
  max-width: ${Grid.DesktopHalf};
  margin: 0 auto;
`;

export const OptionsRows: StyledComponent<'div'> = styled.div`
  margin-bottom: 24px;
`;

export const OptionRow: StyledComponent<'button'> = styled.button.attrs({ type: 'button' })`
  padding: 20px 18px;
  background-color: ${Color.White};
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${Color.Gray300};
  width: 100%;
`;

export const OptionButton: StyledComponent<'div', OptionButtonProps> = styled.div<OptionButtonProps>`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  border: 1px solid ${Color.Black};
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ $theme }: OptionButtonProps): string => $theme === 'circular' ? '50%' : '0'};
`;

export const OptionButtonInner: StyledComponent<'div', OptionButtonInnerProps> = styled.div<OptionButtonInnerProps>`
  width: 8px;
  height: 8px;
  flex-shrink: 0;
  border-radius: ${({ $theme }: OptionButtonProps): string => $theme === 'circular' ? '50%' : '0'};
  background-color: ${({ $active }: OptionButtonInnerProps) => $active ? Color.Black : Color.Transparent};
`;

export const OptionLabel: StyledComponent<'div'> = styled.div`
  text-align: left;
`;
